export default __webpack_public_path__ + "static/media/Ring-Category-List-.a0788d66.jpg";